import { InjectionToken } from '@angular/core';
import type { GooglePayConfig } from './google-pay.interface';

export const GOOGLE_PAY_CONFIG = new InjectionToken<GooglePayConfig>(
  'GooglePayConfig',
);
